import * as React from 'react'
import NextLink from 'next/link'
import { EmtNavLink } from 'emt-components-v2'
import { SxProps } from '@mui/material/styles'
import { useUIStore } from '@/store/ui/uiStore'

type Props = {
  href: string
  active?: boolean
  notification?: boolean
  sx?: SxProps
}

const NavNextLink: React.FC<React.PropsWithChildren<Props>> = ({ href, active, notification, children, sx }) => {
  const { closeDrawer, closeProfileMenu } = useUIStore()
  if (!href.length || href === '#') {
    return null
  }

  return (
    <NextLink href={href} passHref legacyBehavior>
      <EmtNavLink
        onClick={() => {
          closeDrawer
          closeProfileMenu
        }}
        className={active ? 'active' : ''}
        notification={notification}
        sx={sx}
      >
        {children}
      </EmtNavLink>
    </NextLink>
  )
}

export default NavNextLink
